import React, { createContext, useContext, useState } from 'react';

const WritingModeContext = createContext();

export const useWritingMode = () => {
  const context = useContext(WritingModeContext);
  if (!context) {
    throw new Error('useWritingMode must be used within a WritingModeProvider');
  }
  return context;
};

export const WritingModeProvider = ({ children }) => {
  const [writingMode, setWritingMode] = useState('preview'); // 'preview' | 'focus'
  const [isTransitioning, setIsTransitioning] = useState(false);

  const switchMode = (mode) => {
    if (mode === writingMode) return;
    
    setIsTransitioning(true);
    setWritingMode(mode);
    
    // 트랜지션 완료 후 상태 리셋
    setTimeout(() => {
      setIsTransitioning(false);
    }, 300);
  };

  const value = {
    writingMode,
    setWritingMode,
    switchMode,
    isTransitioning,
    isFocusMode: writingMode === 'focus',
    isPreviewMode: writingMode === 'preview',
  };

  return (
    <WritingModeContext.Provider value={value}>
      {children}
    </WritingModeContext.Provider>
  );
};